/**
 * Accessibility for NRW map.
 */
const $ = window.jQuery;

export default {
  attach: function (context, settings) {
    const nrwMap_once = once('nrw-map-once', 'section[data-block-plugin-id="urifm_general_nrw_map"]', context);

    $(nrwMap_once).each(function () {
      let mapWrapper = $(this);

      let nrwMapInterval = setInterval(function() {
        if (mapWrapper.find('.itnrwCustomControl button').length) {
          mapWrapper.find('.itnrwCustomControl button').each(function () {
            $(this).attr('aria-label', $(this).attr('title'));
            $(this).removeAttr('title');
          });

          clearInterval(nrwMapInterval);
        }
      }, 200);
    });
  },
};
